import { BaseService } from "./BaseService";
import { ILanguage } from "Entities";
import { Configuration } from "Configuration";

/**
 * Service for getting languages.
 * @hidden
 */
export class LanguageService extends BaseService {
    
    /**
     * Get all available languages.
     */
    public get(): Promise<ILanguage[]> {
        return this.ajaxget(Configuration.baseUrl + "language");
    }
}
